import React, { FC, useRef, useMemo } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface ECommerceIdeaProjectsProps {
    eCommerceData: any
}

const ECommerceIdeaProjects: FC<ECommerceIdeaProjectsProps> = ({ eCommerceData }) => {
    // Create refs for container and projects
    const containerRef = useRef(null)
    const projectRefs = useRef<Array<React.RefObject<HTMLDivElement>>>([])
    
    // Initialize project refs
    useMemo(() => {
        projectRefs.current = Array(eCommerceData.ECommerceIdeaProjectsData.length)
            .fill(null)
            .map(() => React.createRef<HTMLDivElement>())
    }, [eCommerceData.ECommerceIdeaProjectsData.length])
    

    return (
        <div ref={containerRef}>
            <motion.div 
                className='flex flex-col gap-6 md:gap-10 bg-darkGreyPrimary mt-4 md:mt-8'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                {eCommerceData.ECommerceIdeaProjectsData.map((projects: any, index: number) => {
                     let img = getImage(projects.image ?? "") ?? "";
                    return (
                    <motion.div 
                        key={index}
                        ref={projectRefs.current[index]}
                        className={`flex flex-col justify-center md:flex-${projects.row} px-4 md:px-40 py-6 md:h-96`}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.2 }}
                        transition={{ 
                            duration: 0.6,
                            ease: "easeOut"
                        }}
                    >
                        <motion.div 
                            className={`w-full md:w-[35%] h-48 md:h-auto overflow-hidden bg-blackDark rounded-3xl`}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ 
                                duration: 0.7,
                                ease: "easeOut",
                                delay: 0.2
                            }}
                        >
                            <div className='flex items-center justify-center w-[100%] h-full p-4 md:p-6'>
                                <div className={`w-[100%] h-[100%] overflow-hidden rounded-3xl bg-darkGreyPrimary`}>
                                    {/* <img src={projects.image} className="w-full h-full object-contain" /> */}
                                    <DynamicSVG color='#fff' size='w-full h-full'>{img}</DynamicSVG>
                                </div>
                            </div>
                        </motion.div>
                        <div className={`hidden md:block border-l-2 border-${projects.textColor} my-14`}></div>
                        <div className={`md:hidden border-t-2 border-${projects.textColor} my-4`}></div>
                        <motion.div 
                            className={classNames('flex flex-col w-full md:w-2/4 px-4 md:px-8', `justify-center`)}
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ 
                                duration: 0.5,
                                ease: "easeOut",
                                delay: 0.3
                            }}
                        >
                            <div className={classNames('font-semibold text-2xl md:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                            <div className={classNames('text-greyQuaternary text-base md:text-lg pt-2 md:pt-4', `text-${projects.text}`)}>{projects.subtitle}</div>
                        </motion.div>
                    </motion.div>
                )})}
            </motion.div>
        </div>
    )
}

export default ECommerceIdeaProjects
